import { SxProps } from "@mui/material";
import { Row } from "./Row";

export function DialogTopRightActions({ sx, children }: { sx?: SxProps; children: React.ReactNode }) {
  return (
    <Row
      data-testid="DialogTopRightActions"
      sx={{ position: "absolute", top: "17px", right: "54px", alignItems: "center", ...sx }}
    >
      {children}
    </Row>
  );
}
